import flower from './flower';
import trust from './trust';
import inputs from './inputs';
import adviser from './adviser';

export default {
  flower,
  trust,
  inputs,
  adviser,
};
